import { render, staticRenderFns } from "./ArtistTracker.vue?vue&type=template&id=4afe16ba&scoped=true&"
import script from "./ArtistTracker.vue?vue&type=script&lang=js&"
export * from "./ArtistTracker.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=4afe16ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe16ba",
  null
  
)

export default component.exports